<div class="modal-body vtr-modal-modern-preload"
	[class.page-app]="page != PageNames.LOADING"
	[ngSwitch]="page">
	<div class="content"
		*ngSwitchCase="PageNames.LOADING">
		<div class="loading-page">
			<div class="loading-content"
				#loadingImg
				[style.height.px]="loadingImg.clientWidth * 115 / 386">
				<img src="assets/images/modern-preload/img_modern_preload_loading_386x115_200.jpg" />
			</div>
			<div class="spinner-content w-100 text-center">
				<div class="spinner-border text-primary progress-spinner"
					id="modern-preload-loading"
					attr.aria-label="modern-preload-loading"
					role="status"></div>
			</div>
			<p class="loading-text"
				id="modern-preload-loading-text"
				role="text"
				[innerHTML]="'modernPreload.loadingDescription' | translate"></p>
		</div>
	</div>
	<div class="content"
		*ngSwitchCase="PageNames.APP">
		<div class="app-page">
			<div class="landing-content">
				<div class="title-box">
					<h3 class="title"
						id="modern-preload-title"
						[innerHTML]="'modernPreload.title' | translate"></h3>
					<p class="sub-title mb-0"
						id="modern-preload-sub-title"
						role="text"
						[innerHTML]="'modernPreload.shortDescription' | translate"></p>
				</div>
			</div>
			<div class="app-content">
				<p class="description"
					id="modern-preload-software-description"
					role="text"
					[innerHTML]="'modernPreload.softwareDescription' | translate"></p>
				<div class="row no-gutters"
					id="modern-preload-app-list"
					role="list"
					*ngIf="appList">
					<div class="col-12 col-lg-6"
						*ngFor="let app of appList"
						id="modern-preload-app-item-{{app.udcId}}"
						role="listitem"
						[hidden]="app.category === ModernPreloadAppCategoryEnum.OFFERED">
						<vtr-widget-modern-preload-app [appItem]="app"
							*ngIf="app.category !== ModernPreloadAppCategoryEnum.OFFERED"
							[successIconBase64]="successIconBase64"
							[errorIconBase64]="errorIconBase64"
							[downloadIconBase64]="downloadIconBase64"
							(setAppCheckStatusEmitter)="setAppCheckStatus(app)"
							(setRedeemStatusEmitter)="setRedeemStatus(app)"
							(launchURLEmitter)="launchURL(app.redemptionURL)"
							(checkedAppEmitter)="checkedApp()"></vtr-widget-modern-preload-app>
					</div>
					<p class="description w-100 py-4"
						*ngIf="isIncludesOfferedApp"
						role="text"
						id="modern-preload-note-offers">{{ 'modernPreload.noteExclusiveOffers' | translate }}</p>
					<div class="col-12 col-lg-6"
						*ngFor="let app of appList"
						id="modern-preload-app-item-{{app.udcId}}"
						role="listitem"
						[hidden]="app.category !== ModernPreloadAppCategoryEnum.OFFERED">
						<vtr-widget-modern-preload-app [appItem]="app"
							*ngIf="app.category === ModernPreloadAppCategoryEnum.OFFERED"
							[successIconBase64]="successIconBase64"
							[errorIconBase64]="errorIconBase64"
							[downloadIconBase64]="downloadIconBase64"
							(setAppCheckStatusEmitter)="setAppCheckStatus(app)"
							(setRedeemStatusEmitter)="setRedeemStatus(app)"
							(launchURLEmitter)="launchURL(app.redemptionURL)"
							(checkedAppEmitter)="checkedApp()"></vtr-widget-modern-preload-app>
					</div>
				</div>
				<div class="button-content mb-4">
					<div class="btn-box mr-5"
						[ngSwitch]="modernPreloadService.DownloadButtonStatus">
						<vtr-ui-button *ngSwitchCase="DownloadButtonStatusEnum.DOWNLOAD"
							(onClick)="installEntitledApp()"
							linkId="modern-preload-download-button"
							[isFullWidth]="true"
							[isDisabled]="checkedAppList.length === 0"
							[label]="'modernPreload.download' | translate">
						</vtr-ui-button>
						<vtr-ui-button *ngSwitchCase="DownloadButtonStatusEnum.RESTART_DOWNLOAD"
							(onClick)="installEntitledApp()"
							linkId="modern-preload-restart-download-button"
							[isFullWidth]="true"
							[isDisabled]="checkedAppList.length === 0 || modernPreloadService.IsCancelInstall"
							[label]="'modernPreload.restartDownload' | translate">
						</vtr-ui-button>
						<vtr-ui-button *ngSwitchCase="DownloadButtonStatusEnum.DOWNLOADING"
							linkId="modern-preload-downloading-button"
							[isFullWidth]="true"
							[isDisabled]="true"
							[label]="'modernPreload.downloading' | translate">
						</vtr-ui-button>
					</div>
					<a *ngIf="modernPreloadService.DownloadButtonStatus !== DownloadButtonStatusEnum.DOWNLOADING"
						id="modern-preload-skip-button"
						attr.aria-label="modern-preload-skip-button"
						href="javascript:;"
						class="btn-skip"
						[title]="'modernPreload.skip' | translate"
						(click)="closeModal()"
						[innerHTML]="'modernPreload.skip' | translate"></a>
					<a *ngIf="modernPreloadService.DownloadButtonStatus === DownloadButtonStatusEnum.DOWNLOADING"
						id="modern-preload-cancel-button"
						attr.aria-label="modern-preload-cancel-button"
						href="javascript:;"
						class="btn-skip"
						(click)="cancel()"
						[title]="'modernPreload.cancel' | translate"
						[innerHTML]="'modernPreload.cancel' | translate"></a>
				</div>
				<p class="bottom-tips"
					*ngIf="!isAppInstallError"
					id="modern-preload-downloading-note"
					role="text"
					[innerHTML]="'modernPreload.noteDownloading' | translate"></p>
				<p class="bottom-tips"
					*ngIf="isAppInstallError"
					id="modern-preload-failed-download-note"
					role="text"
					[innerHTML]="'modernPreload.noteFailedDownload' | translate"></p>
			</div>
		</div>
	</div>
	<div class="content"
		*ngSwitchCase="PageNames.ERROR">
		<div class="app-page">
			<div class="landing-content">
				<div class="title-box">
					<h3 class="title"
						id="modern-preload-title"
						[innerHTML]="'modernPreload.title' | translate"></h3>
					<p class="sub-title mb-0"
						id="modern-preload-sub-title"
						role="text"
						[innerHTML]="'modernPreload.shortDescription' | translate"></p>
				</div>
			</div>
			<div class="error-content">
				<div class="d-flex">
					<div class="error-icon">
						<img [src]="errorIconBase64 | sanitize : 'resourceUrl'"
							alt=""
							srcset="">
					</div>
					<div class="error-box pt-2">
						<p class="bottom-tips mb-5"
							id="modern-preload-error-description"
							role="text"
							[innerHTML]="'modernPreload.errorDescription' | translate"></p>
						<div class="button-content mb-4">
							<div class="btn-box mr-5">
								<vtr-ui-button (onClick)="retry()"
									linkId="modern-preload-retry-button"
									[isFullWidth]="true"
									[label]="'modernPreload.retry' | translate">
								</vtr-ui-button>
							</div>
							<a id="modern-preload-skip-button"
								attr.aria-label="modern-preload-skip-button"
								href="javascript:;"
								class="btn-skip"
								[title]="'modernPreload.skip' | translate"
								(click)="closeModal()"
								[innerHTML]="'modernPreload.skip' | translate"></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div role="button"
		class="close-btn"
		tabindex="0"
		[class.show]="page != PageNames.LOADING"
		id="modern-preload-close-button"
		attr.aria-label="modern-preload-close-button"
		(keyup.enter)="closeModal()"
		(click)="closeModal()">
		<img [src]=" 'assets/icons/Close-white.svg' | svgInline | async"
			alt=""
			srcset="">
	</div>
</div>
